/** @format */

import { IEnvironment, commonEnvironment } from './common.environment';

import { LoggerLevel } from '@shared/data-access/services';

const redirectingServiceBase = '/myaccount/services/redirectingservice';

export const environment: IEnvironment = {
	...commonEnvironment,
	environmentName: 'prod',
	basePath: 'dcsg-ngx-myaccount',
	pricing: {
		path: '/discount/details/',
		env: 'https://dcsg-prod.api.dickssportinggoods.com/',
		esbEnvironmentHeader: 'prdlive'
	},
	api: {
		...commonEnvironment.api,
		homr: {
			baseUrl: '/',
			previewLinks: true,
			proxy: {
				path: `/dcsg-ngx-home/homr/v2/api/`,
				timeout: '15000'
			},
			url: 'https://www.dickssportinggoods.com/dcsg-ngx-home/homr/v2/api',
			scene7Url: '//dks.scene7.com/is/image/dksfed/',
			scene7UrlCDN: '//dks.scene7.com/is/image/dkscdn/'
		},
		reactMarginals: {
			header: {
				AZ: 'https://prod-ecom-responsive-header-page.iso.ap01.pcf.dcsg.com',
				AZ2: 'https://prod-ecom-responsive-header-page.iso.ap02.pcf.dcsg.com',
				VS: 'https://prod-ecom-responsive-header-page.iso.ap02.pcf.dcsg.com'
			},
			footer: {
				AZ: 'https://prod-ecom-footer-page.iso.ap01.pcf.dcsg.com',
				AZ2: 'https://prod-ecom-footer-page.iso.ap02.pcf.dcsg.com',
				VS: 'https://prod-ecom-footer-page.iso.ap01.pcf.dcsg.com'
			},
			calia: {
				AZ: 'https://prod-calia-navigation.iso.ap01.pcf.dcsg.com',
				AZ2: 'https://prod-calia-navigation.iso.ap02.pcf.dcsg.com',
				VS: 'https://prod-calia-navigation.iso.ap01.pcf.dcsg.com'
			},
			footerHTMLId: 'react-footer-insert' //'responsive-footer'
		},
		spring: {
			baseUrl: '/',
			gatewayUrl: 'https://gateway-server.iso.gp01.pcf.dcsg.com/',
			autoSuggestUrl: 'https://prod-catalog-autosuggest-api.dickssportinggoods.com/',
			searchTermUrl: 'https://prod-catalog-product-api.dickssportinggoods.com/',
			taxonomyUrl: '/dcsg-ngx-category/taxo/api/',
			microServiceProxy: {
				logger: {
					path: `/maui/spring/msvc/logger/`,
					timeout: '30000'
				},
				recommendations: {
					path: '/api/spring/msvc/ds/v1/',
					timeout: '15000'
				}
			}
		},
		esb: {
			baseUrl: '/',
			gatewayUrl: 'https://gateway.dcsg.com/',
			gatewayUrlProxy: {
				browser: '/dcsg-ngx-header/esb/api/',
				server: 'http://localhost/dcsg-ngx-header/esb/api/'
			},
			promotions: {
				apiKey: 'c0fcfbe0-9983-11e7-b506-c779759784e8',
				env: 'prdlive',
				previewTime: '',
				channelId: '-1'
			}
		},
		brandify: {
			brandifyBaseUrl: 'https://hosted.where2getit.com/'
		},
		esbBaseUrl: 'https://gateway.dcsg.com/',
		footerUrl: 'https://ceops.dickssportinggoods.com/',
		tickerUrl: 'https://fdhmfhecfi.execute-api.us-east-1.amazonaws.com/prod/',
		seo: 'https://api-search.dickssportinggoods.com/',
		ceops: 'https://ceops.dickssportinggoods.com',
		elastic: {
			availability: `${redirectingServiceBase}/availabilityservice`,
			searchTermUrl: 'https://prod-catalog-product-api.dickssportinggoods.com/'
		},
		avsApi: {
			origin: 'https://avs.dickssportinggoods.com',
			baseUrl: '/avs/verifyAddress',
			healthCheckUrl: '/avs/health',
			proxyPath: '/myaccount'
		},
		avsApiV2: {
			origin: 'https://avs.dickssportinggoods.com',
			baseUrl: '/v2/address/verification',
			proxyPath: '/myaccount'
		},
		criteo: {
			baseUrl: 'https://d.us.criteo.com/delivery/retailmedia?',
			nolog: 0,
			partnerId: {
				dsg: 25953,
				gg: 35855
			}
		}
	},
	apiTokens: {
		brandify: {
			storeLocator: {
				dsg: '8D669860-73FB-11E8-8752-FF2F0D70A832',
				gg: 'CE23B360-C828-11E4-B146-ED9AA38844B8'
			}
		},
		esb: {
			api: '38d00cb0-6e1b-11e6-8390-8c24708cfd68',
			api2: '9b59c9e0-6710-11e7-bdcc-80098dffd0fa',
			identity: 'af727360-d115-11e5-ab08-be8d24eccbe9',
			myaccount: 'd0b85d50-d115-11e5-ab08-b8fc4c91c2b3'
		},
		exComm: {
			baseUrl: '/myaccount/services/redirectingservice/apimservice',
			apimSecret: '1223085112fb446aa5c8ed2f745f6886'
		},
		contentAPI: {
			key: 'VDJSNWMzTmxlVUpsZEdFPSA5U1QmWTI8PWF8R0IoOWtBLEdVYzsmY1JMelBYI2k='
		},
		party: {
			partnerKey: 'botf',
			secretKey: 'KqIj3Fofw0255D06Q5bl'
		},
		branchIo: {
			dsg: {
				branchKey: 'key_live_ha4Fjjyi2wV5D2EEXnwktkbaFBdevCjn'
			},
			gg: {
				branchKey: 'key_live_bp0CfkBl7CHWLSCIhYW59iglwvigy2qk'
			}
		}
	},
	catOvrGrpId: {
		dsg: '3074457345618270104',
		gg: '10501',
		pl: '',
		g3: ''
	},
	searchbyTermTypeParam: '1000',
	logging: {
		client: {
			level: LoggerLevel.WARN
		},
		xhr: {
			level: LoggerLevel.LOG,
			url: 'https://log-publisher.cfapps.io/publish'
		}
	},
	esbEnvironmentHeader: 'auxlive',
	inventory: {
		locationId: 0
	},
	production: true,
	thirdParty: {
		// ...commonEnvironment.thirdParty,
		auth0: {
			dsg: {
				enabled: true
			},
			gg: {
				enabled: true
			},
			pl: {
				enabled: false
			},
			calia: {
				enabled: false
			},
			vrst: {
				enabled: false
			},
			g3: {
				enabled: false
			}
		},
		btt: {
			dsg: 'https://dsg2.btttag.com/btt.js',
			gg: 'https://golfgalaxy2.btttag.com/btt.js',
			pl: '',
			g3: ''
		},
		bv: {
			store: {
				dsg: {
					script: 'https://apps.bazaarvoice.com/deployments/dsg/main_site/production/en_US/bv.js'
				},
				gg: {
					script: 'https://apps.bazaarvoice.com/deployments/golfgalaxy/main_site/production/en_US/bv.js'
				},
				pl: {
					script: 'https://apps.bazaarvoice.com/deployments/publiclands/main_site/production/en_US/bv.js'
				}
			}
		},
		soasta: {
			dsg: 'https://c.go-mpulse.net/boomerang/Y7NJM-H6YK3-37AQ8-UY6YB-3K3S9',
			gg: 'https://c.go-mpulse.net/boomerang/C5JH9-QVK3R-W7E4D-F63VJ-8WKUM',
			pl: '',
			g3: ''
		},
		scene7: {
			baseConfig: {
				baseUrl: 'https://dks.scene7.com/',
				cdn: 'GolfGalaxy/',
				css: 'skins/Scene7SharedAssets/htmlviewerskins/css/html5_mixedmediaviewer_light.css',
				imageDirectory: 'is/image/',
				queryString: '?req=set,json,UTF-8',
				sdkUrl: 's7sdk/3.3/js/s7sdk',
				secureBaseUrl: 'https://dks.scene7.com/',
				videoDirectory: 'is/content/',
				viewerUrl: 's7viewers/html5/js/MixedMediaViewer.js'
			},
			url: 'https://dks.scene7.com/is/image/dkscdn/',
			suffix: '$DSG_ProductCard$'
		},
		sessionCam: {
			enabled: true
		},
		searchDex: {
			gatewayUrlProxy: {
				path: `/dcsg-ngx-home/sdxincludes/api/`,
				timeout: '15000'
			},
			store: {
				calia: {
					baseUrl: 'https://www.dickssportinggoods.com/products/includes/'
				},
				dsg: {
					baseUrl: 'https://www.dickssportinggoods.com/products/includes/'
				},
				gg: {
					baseUrl: 'https://www.golfgalaxy.com/products/includes/'
				},
				pl: {
					baseUrl: 'https://www.publiclands.com/products/includes/'
				},
				g3: {
					baseUrl: 'https://www.goinggoinggone.com/products/includes/'
				}
			}
		},
		tealium: {
			enabled: true,
			script: {
				dsg: {
					baseUrl: 'https://tag.dickssportinggoods.com/utag.js'
				},
				gg: {
					baseUrl: 'https://tag.golfgalaxy.com/utag.js'
				},
				pl: {
					baseUrl: 'https://tag.publiclands.com/utag.js'
				},
				g3: {
					baseUrl: 'https://tag.goinggoinggone.com/utag.js'
				},
				calia: {
					baseUrl: 'https://tag.calia.com/utag.js'
				}
			}
		}
	},
	myAccount: {
		...commonEnvironment.myAccount,
		authServiceBaseUrl: 'https://myaccount.dickssportinggoods.com/prod/authservice',
		redirectPaths: {
			returnToMyAccount: {
				...commonEnvironment.myAccount.redirectPaths.returnToMyAccount,
				dsg: 'https://dickssportinggoods.app.link/xLt5Nq1X7Hb',
				gg: 'https://golfgalaxy.app.link/KntoSUa17Hb'
			}
		}
	},
	feature: {
		...commonEnvironment.feature,
		dsg: {
			ceops: true,
			textSubscriptions: true,
			bopisProxyPickup: true,
			erewardsEnabled: true,
			creditCardOfferEnabled: true,
			scorecardGoldEnabled: true,
			availableOffersEnabled: true,
			rewardDeliveryOptionsEnabled: true,
			nikeConnectedEnabled: true,
			hitTraxEnabled: true
		},
		gg: {
			ceops: true,
			textSubscriptions: false,
			bopisProxyPickup: true,
			erewardsEnabled: true,
			creditCardOfferEnabled: true,
			scorecardGoldEnabled: true,
			availableOffersEnabled: true,
			rewardDeliveryOptionsEnabled: true,
			hitTraxEnabled: false
		},
		pl: {
			ceops: true,
			textSubscriptions: false,
			bopisProxyPickup: false,
			erewardsEnabled: false,
			creditCardOfferEnabled: true,
			scorecardGoldEnabled: false,
			availableOffersEnabled: true,
			rewardDeliveryOptionsEnabled: false,
			hitTraxEnabled: false
		},
		calia: {
			ceops: true,
			textSubscriptions: false,
			bopisProxyPickup: false,
			erewardsEnabled: true,
			creditCardOfferEnabled: true,
			scorecardGoldEnabled: true,
			availableOffersEnabled: true,
			rewardDeliveryOptionsEnabled: true,
			hitTraxEnabled: false
		},
		vrst: {
			ceops: false,
			textSubscriptions: false,
			bopisProxyPickup: false,
			erewardsEnabled: true,
			creditCardOfferEnabled: true,
			scorecardGoldEnabled: true,
			availableOffersEnabled: true,
			rewardDeliveryOptionsEnabled: true,
			hitTraxEnabled: false
		},
		g3: {
			ceops: true,
			textSubscriptions: false,
			bopisProxyPickup: false,
			erewardsEnabled: false,
			creditCardOfferEnabled: false,
			scorecardGoldEnabled: false,
			availableOffersEnabled: false,
			rewardDeliveryOptionsEnabled: true,
			hitTraxEnabled: false
		}
	},
	identityServiceKey: {
		partnerKey: 'MyAccount',
		secretKey: 'PsbiPfwWl9inJxvh3fxN'
	},
	creditServiceKey: {
		partnerKey: 'botf',
		secretKey: 'KqIj3Fofw0255D06Q5bl'
	},
	offerDate: {
		startDateString: '2020-12-19T00:00:00',
		endDateString: '2020-12-20T23:59:59'
	},
	killSwitch: {
		crossChainBopis: {
			calia: false,
			dsg: true,
			gg: true,
			vrst: false,
			pl: false,
			g3: false
		},
		nikeConnectedEnabled: {
			dsg: true,
			gg: false,
			calia: false,
			vrst: false,
			pl: false,
			g3: false
		},
		hitTraxEnabled: {
			dsg: true,
			gg: false,
			calia: false,
			vrst: false,
			pl: false,
			g3: false
		},
		scorecardGoldEnabled: {
			dsg: true,
			gg: true,
			calia: true,
			vrst: true,
			pl: false,
			g3: false
		},
		listsEnabled: {
			dsg: false,
			gg: false,
			calia: false,
			vrst: false,
			pl: false,
			g3: false
		},
		nikeConnectedSummaryEnabled: {
			dsg: true,
			gg: false,
			calia: false,
			vrst: false,
			pl: false,
			g3: false
		},
		useNewSyfApi: {
			dsg: true,
			gg: true,
			calia: false,
			vrst: false,
			pl: true,
			g3: false
		},
		inStoreDetailsEnabled: {
			dsg: true,
			gg: true,
			calia: false,
			vrst: false,
			pl: true,
			g3: false
		},
		mfaEnabled: {
			dsg: true,
			gg: true,
			calia: true,
			vrst: true,
			pl: true,
			g3: true
		},
		shareFavoritesEnabled: {
			dsg: false,
			gg: false,
			pl: false,
			g3: false
		},
		showDSRecommendations: {
			dsg: false,
			gg: false,
			pl: false,
			g3: false
		},
		showDSRecommendationsOD: {
			dsg: false,
			gg: false,
			pl: false,
			g3: false
		},
		skuFavoritesEnabled: {
			dsg: false,
			gg: false,
			pl: false,
			g3: false
		},
		eventReservationsEnabled: {
			dsg: false,
			gg: false,
			pl: false,
			g3: false
		},
		shareListDeepLinkingEnabled: {
			dsg: false,
			gg: false,
			pl: false,
			g3: false
		},
		dataDrivenEnabled: {
			dsg: false,
			gg: false,
			pl: false,
			g3: false
		},
		trackOrderByEmailEnabled: {
			dsg: false,
			gg: false,
			pl: false,
			g3: false
		},
		giftcardCtaEnabled: {
			dsg: false,
			gg: false,
			pl: false,
			g3: false
		},
		nudgeShareEnabled: {
			dsg: false,
			gg: false,
			pl: false
		},
		oosListEnabled: {
			dsg: false,
			gg: false,
			pl: false
		},
		useAuthGuardSetInterval: {
			dsg: false,
			gg: false,
			pl: false,
			g3: false
		},
		enableTooltipSurvey: {
			dsg: true,
			gg: true,
			pl: false,
			g3: false
		},
		btsDashUpdates: {
			dsg: true,
			gg: false,
			pl: false,
			g3: false
		}
	}
};
